module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-danger"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Latest Members")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("8 New Members")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "users-list clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user1-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("Today")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user8-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Norman")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("Yesterday")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user7-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Jane")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("12 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user6-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("John")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("12 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user2-160x160.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Alexander")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("13 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user5-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sarah")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("14 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user4-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nora")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("15 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nadia")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("15 Jan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('a', {
    staticClass: "uppercase",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("View All Users")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62320192!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VAUserList.vue
// module id = 521
// module chunks = 1